import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // serverUrl: 'http://192.168.3.51:8898/',
    // serverUrl: 'http://192.168.3.46:8019/',
    // serverUrl: 'http://192.168.3.40:8898/',
    // serverUrl: 'http://192.168.3.52:8898/',
    serverUrl: 'https://fs.fanyyy.com/search/'
  
    // serverUrl:'https://96aa8ddf7977.ngrok-free.app/'
  },
  mutations: { setPermissions(state, data) { state.permissions = data } },
  actions: {
  },
  modules: {
  }
})
